import axios from 'axios';
import loadReferenceShortcode from './front/shortcodes/reference';
import initTogglers from './front/togglers';
import loadContentMenu from './front/shortcodes/contentMenu';
import './front/shortcodes/summaryList';
import './front/shortcodes/collapse'; // "Rendre repliable" blocks

import Sticker from './front/Animation/Sticker';
import Animation from './front/Animation';
import Parallaxer from './front/Animation/Parallaxer';
import Affixer from './front/Animation/affixer';

import ScrollFadeGallery from './front/galleries/ScrollFadeGallery';
import './front/Style/front.scss';
import {isOnScreen} from './front/Animation/ScrollHelpers';

const $ = jQuery;

const handleSave = () => {
	let modalFlexItems = $(".modal-form__flex_item");

	if($('.save-post-toggle .save-post-svg-container').length > 0){
		
		$(document).on('click',".save-post-toggle .save-post-svg-container",function(){
			$(".save-post-toggle .save-post-svg-container").each(function(i,el){
				$(el).parent().find(".sign-in_container").addClass('d-none');
			});
			$(this).parent().find(".sign-in_container").removeClass('d-none');
			const elem = $(this).parent().find(".sign-in_container")[0];
			const elementBoundering = $(this).parent().find(".sign-in_container")[0].getBoundingClientRect();
			const top = elementBoundering.top;
			const bottom = elementBoundering.bottom;
			const width = elementBoundering.width;
			const left = elementBoundering.left;
			const right = elementBoundering.right;
			if(left < 0 && top > 0){
				elem.style.transform = `translateX(${-left+26 - width/2}px)`;
			}
			if(window.innerWidth-right < 0 && top > 0){
				elem.style.transform = `translateX(${window.innerWidth-right-26- width/2}px)`;
			}
			
			if(top < 0 && window.innerWidth-right > 0){
				// alert(`top only`);
				elem.style.transform = `translate(${-width/2}px,${-top+26}px)`;
			}
			if(top < 0 && window.innerWidth-right < 0){
				// alert(`top and right ${top} ${right}`);
				elem.style.transform = `translate(${window.innerWidth-right-26- width/2}px,${-top+26}px)`;
			}
			
			if(top < 0 && left > 0){
				// alert(`top ${top}`);
				elem.style.transform = `translate(${-width/2}px,${-top+26}px)`;
			}
			if(top < 0 && left < 0){
				// alert(`top ${top}`);
				elem.style.transform = `translate(${-left+26 - width/2}px,${-top+26}px)`;
			}
			
		});
	}

	if($('.save-post-toggle .close_container').length > 0){
		$(document).on('click',".save-post-toggle .close_container",function(){
			$(this).parent().addClass('d-none');
		});
	}
	
	
	$(document).on('click',".toggle-from-modal",function(e){
		let dataCarrouseelOrder =   $(this).data('carousselorder');
		let dataLoginOrder =   $(this).data('loginorder');
		if(document.querySelectorAll(".search-logo svg").length > 0){
			[...document.querySelectorAll(".search-logo svg")].forEach(el=>{
				if(el.classList.contains("white") && dataCarrouseelOrder=="2" && dataLoginOrder=="1"){
					el.classList.remove("white");
				}else{
					el.classList.add("white");
				}
			});  
		}
		if(dataCarrouseelOrder=="1" && dataLoginOrder=="2"){
			document.querySelector(".close-modal-form").classList.remove("white");
		}else{
			document.querySelector(".close-modal-form").classList.add("white");
		}
		
		if(modalFlexItems.length > 0){
			[...modalFlexItems].forEach(element => {
				
				if(element.id == "carouselLoginIndicators"){
					element.setAttribute("data-order",dataCarrouseelOrder);
				}else if(element.id == "login-section"){
					element.setAttribute("data-order",dataLoginOrder);
				}
			});
		}
		$('.modal-login form').hide();
		$(`.modal-login form#${$(this).data('showForm')}`).show();
	});
}

const isEmpty = value =>
  value === undefined ||
  value === null ||
  (typeof value === "object" && Object.keys(value).length === 0) ||
  (typeof value === "string" && value.trim().length === 0);

const loadMoreSetup = ()=>{
	$('body').on('click', '.load-more-container', function(e){
		const url = $(this).attr('apiUrl');
		

		const localizedUrl = url+'?lang='+inkube_front_data.currentLang;
		let qv = $(this).attr('query');
		const $button = $(this);
		const query = window[qv];
		let newOffset = query.query.offset?query.query.offset:0;
		let delta = query.query.posts_per_pagenext || query.query.users_per_pagenext || query.query.terms_per_pagenext;
		newOffset = newOffset + delta;
		query.query.offset = newOffset;
		let headers={};

		if(!isEmpty(window.profile_nonce)){
			headers = {
				"X-WP-Nonce"  : window.profile_nonce,
				"Accept": "application/json",
				"Content-Type": "application/json",
			};
		}


		axios.post(localizedUrl, query,{
			headers
		})
		.then(response=>{
			$button.before(response.data.html);
			$button.parent().trigger('loaded-more-content', response.data.html);
			$button.remove();
			var event = new Event('loaded-more-content');
			document.dispatchEvent(event);
		})
		.catch(e=>{
			$button.addClass('has-error');
			alert(e);
		});
	});
	//$('.load-more-container').click();
}
const ajaxSearch = (url, query, resultHolder,callback=null)=>{
	if (!resultHolder || !resultHolder.html){
		console.error('ajaxSearch needs a jQuery element in 2nd argument');
		return;
	}
	axios.post(url, query)
	.then(response=>{
		resultHolder.html(response.data.html);
		if(callback) callback();
	})
	.catch(e=>{
		console.error(e, query);
	});
}

const loadAsyncAssets  = ()=>{
	let load = (el,data)=>{
		if (el.attr('data-load-current')=='loading'){
			return;
		}
		if ($(window).width()<768 && el.attr('data-load-current')!=data.sm){
			el.attr('data-load-current', 'loading');

			$.get(data.sm, function(data) {
				let innerHTML = new XMLSerializer().serializeToString(data.documentElement);
				if (innerHTML){
					el.html(innerHTML);
				}
			});
		}

		if ($(window).width()>=768 && el.attr('data-load-current')!=data.md){
			el.attr('data-load-current', 'loading');
			$.get(data.md, function(data) {
				let innerHTML = new XMLSerializer().serializeToString(data.documentElement);
				if (innerHTML){
					el.html(innerHTML);
				}
			}).fail(()=>{
				el.find('.errors').html('Erreur lors du chargement...')
			});
		}
		
		
	}

	$('[data-load-sm], [data-load-md]').each(function(){
		let prefix = $(this).attr('data-load-prefix');
		
		prefix = prefix?prefix:'';
		let onLoad = $(this).attr('data-on-load');
		onLoad = onLoad?onLoad:null;
		let paths={
			sm: $(this).data('loadSm'),
			md: $(this).data('loadMd')
		}
		paths.sm = paths.sm?paths.sm:(paths.md?paths.md:'');
		paths.md = paths.md?paths.md:paths.sm;
		let data = {
			sm: prefix+paths.sm,
			md: prefix+paths.md,
			onLoad: onLoad
		}
		if (!data.sm && !data.md) return;
		
		let $this = $(this);
		load($(this), data);
		$(window).resize(function(){
			load($this, data);
		});
	});
}

window.searchPosts = ajaxSearch;
window.loadAsyncAssets = loadAsyncAssets;
window.axios = axios;
$(document).ready(loadAsyncAssets);
$(document).ready(loadMoreSetup);
$(document).ready(loadReferenceShortcode);
window.loadContentMenu = loadContentMenu;
$(document).ready(initTogglers);
$(document).ready(handleSave);

class InkubeManager {
	constructor(){
		// Players (video.js + wavesurfer) are loaded on demand — see ensurePlayers().
		this.players = null;
		this._playersPromise = null;
		this.refreshHooks = [];

	}

	// Lazily load the heavy media-player bundle (video.js + wavesurfer + youtube) into
	// its own chunk, only when a player is actually on the page or in the editor.
	ensurePlayers(){
		if (this._playersPromise) return this._playersPromise;
		this._playersPromise = import('./front/players').then(m => {
			const Players = m.default;
			this.players = new Players();
			this.players.refresh();
			return this.players;
		});
		return this._playersPromise;
	}
	
	registerInitializer(id, fn){
		this.refreshHooks[id] = fn;
		return this;
	}
	refresh(){
		for (var k in this.refreshHooks){
			this.refreshHooks[k]();
		}
	}
}

window.Inkube = new InkubeManager();

// Load the player chunk only when needed: a player element is present, or we're in
// the editor (wp_inkube_data is localized for editors, which insert players live).
const inkubeHasPlayer = () => !!document.querySelector(
	'.video-js, .inkube-player .podcast-player[data-source], [data-shortcode-tag="videoplayer"], [data-shortcode-tag="audioplayer"]'
);
$(document).ready(()=>{
	if (inkubeHasPlayer() || (typeof window.wp_inkube_data !== 'undefined')){
		Inkube.ensurePlayers();
	}
});
$.fn.load = function(callback){ $(window).on("load", callback) };

export default Inkube;

